module.exports = __webpack_public_path__ + "img/trap-gray.05e0bbd0.png";